module.exports = __webpack_public_path__ + "img/active-zhiyin.1f0cef63.png";